import cx from 'classnames'
import { closeModal, openCommonModal } from 'sb-modal'

import messages from './messages'
import s from './SkipAMonthRefundModal.scss'


export const openSkipAMonthRefundModal = () => (
  new Promise<'REFUND' | 'RECEIVE'>((resolve) => {
    const choose = (refund: boolean) => () => {
      resolve(refund ? 'REFUND' : 'RECEIVE')
    }

    openCommonModal({
      className: cx('humbleBgColor', s.modal),
      iconName: 'assembly',
      iconColor: 'brand-30',
      title: messages.title,
      text: messages.text,
      primaryButton: {
        title: messages.buttons.receive,
        onClick: choose(false),
      },
      secondaryButton: {
        title: messages.buttons.refund,
        onClick: choose(true),
      },
      onClose: choose(false),
      dataTestId: 'SkipAMonthRefundModal',
    })
  })
)

export const closeSkipAMonthRefundModal = () => {
  closeModal('common')
}
